// Constants from utils
export const HUNDRED = 100;
export const THOUSAND = 1000;
export const LAKH = HUNDRED * THOUSAND;
export const CRORE = HUNDRED * LAKH;
export const MILLION = THOUSAND * THOUSAND;
export const BILLION = THOUSAND * MILLION;

export const BY_DEFAULT_CARDS_DESKTOP = 3;
export const BY_DEFAULT_CARDS_TABLET = 2;
export const SHOW_NO_OF_CARDS_ONE = 1;
export const DIVIDED_BY_DESKTOP = 3.2;
export const DIVIDED_BY_TABLET = 2.2;
